module.exports = __webpack_public_path__ + "static/img/lime-m.bc5ab2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/lime-m.jpg
// module id = aJI9
// module chunks = 0